import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=445221d0"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445221d0')) {
      api.createRecord('445221d0', component.options)
    } else {
      api.reload('445221d0', component.options)
    }
    module.hot.accept("./Categories.vue?vue&type=template&id=445221d0", function () {
      api.rerender('445221d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Categories.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Categories.vue
// module id = 14
// module chunks = 0